// extracted by mini-css-extract-plugin
module.exports = {"container":"PriceAndReviews_container__Eu89e","ratings":"PriceAndReviews_ratings__GmUan","wrapOnMobile":"PriceAndReviews_wrapOnMobile__A8imB"};